// Vendor libraries
import { ElementRef, inject } from '@angular/core';
// Services
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import * as i0 from "@angular/core";
export class FolderableBase {
    constructor() {
        this.elemRef = inject(ElementRef);
        this.bulkActionSelectionService = inject(BulkActionSelectionService);
    }
    get ancestorFolderIsSelected() {
        // If there is a disabled ancestor, then an ancestor folder has been selected.
        // We use the css `disabled` class to detect whether an ancestor has been selected as a simpler alternative
        // to managing a mapping of ancestor to child item types and ids.
        const { nativeElement } = this.elemRef;
        return nativeElement.closest('.disabled') !== null;
    }
    get itemSelectionDisabled() {
        if (!this.bulkActionSelectionService.bulkActionMode)
            return false;
        return this.folderable.item.sharing.owner_id !== window.USER.userId || this.ancestorFolderIsSelected;
    }
    get itemIsSelected() {
        if (this.ancestorFolderIsSelected &&
            this.bulkActionSelectionService.isSelected(this.folderable.resourceType, this.folderable.item.id)) {
            // When an ancestor folder is selected, assume all sub-items are included as part of its selection.
            this.bulkActionSelectionService.deselectItem(this.folderable.resourceType, this.folderable.item.id);
        }
        return this.bulkActionSelectionService.isSelected(this.folderable.resourceType, this.folderable.item.id);
    }
}
FolderableBase.ɵfac = function FolderableBase_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableBase)(); };
FolderableBase.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: FolderableBase, inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo" } });
